import { createSelector } from '@reduxjs/toolkit';

import { lookupsApi } from '../api';

const emptyArr: unknown[] = [];
const activityCategoriesQuery = createSelector([state => state], state => {
  const result = lookupsApi.endpoints.lookupActivityCategories.select()(state);

  return result;
});
export const activityCategoriesSel = createSelector(
  activityCategoriesQuery,
  response => response.data! || emptyArr,
);
